import React, { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { useLang } from "../LangContext";
import { translateText } from "../api";

export default function TranslateButton({ text, sourceLang = "it", cacheKey, className = "" }) {
  const { lang, t } = useLang();
  const [translation, setTranslation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const source = (sourceLang || "it").split("-")[0];
  const target = (lang || "it").split("-")[0];

  if (!text?.trim() || source === target) return null;

  async function onTranslate() {
    if (translation) {
      setTranslation(null);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await translateText({
        text: text.trim(),
        target_lang: target,
        source_lang: source,
        cache_key: cacheKey,
      });
      setTranslation(res.translation);
    } catch (e) {
      setError(e?.response?.data?.detail || "Traduzione non disponibile");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={className}>
      <button
        type="button"
        onClick={onTranslate}
        disabled={loading}
        data-testid="translate-button"
        className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-terracotta hover:text-ink border border-terracotta/40 rounded-full px-3 py-1.5 transition-colors disabled:opacity-50"
      >
        {loading ? <Loader2 size={12} className="animate-spin" /> : <Languages size={12} />}
        {translation ? "Mostra originale" : (t.ui?.show_translation || "Visualizza traduzione")}
      </button>
      {error && <p className="text-terracotta text-xs mt-2">{error}</p>}
      {translation && (
        <div
          className="mt-3 p-4 bg-parchment2/80 border border-borderline rounded-xl text-sm text-ink leading-relaxed"
          data-testid="translated-text"
        >
          {translation}
        </div>
      )}
    </div>
  );
}
